import { Button, ListPage, RefreshButton } from '@skylabs-digital/backoffice-kit';
import { Plus } from 'lucide-react';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';

import { apiKeysApi } from '../api/apiKeys.api';
import { ApiKeyList } from '../components/api-keys/ApiKeyList';

export function ApiKeysPage() {
  const { data: keys, loading, error, refetch } = apiKeysApi.useList();
  const { mutate: revokeKey } = apiKeysApi.useDelete();

  const handleRevoke = useCallback(
    async (id: string) => {
      await revokeKey(id);
      await refetch();
    },
    [revokeKey, refetch],
  );

  return (
    <ListPage
      title="API Keys"
      description="Issue, revoke, and audit API keys with cross-app scopes."
      actions={
        <div className="flex items-center gap-2">
          <RefreshButton onRefresh={refetch} isRefreshing={loading} />
          <Button asChild>
            <Link to="/api-keys/new">
              <Plus /> Create API key
            </Link>
          </Button>
        </div>
      }
    >
      <ApiKeyList
        keys={keys ?? []}
        loading={loading}
        error={error as Error | null | undefined}
        onRevoke={handleRevoke}
      />
    </ListPage>
  );
}
